import { render, staticRenderFns } from "./BucketAdminChannels.vue?vue&type=template&id=8854a886&scoped=true&"
import script from "./BucketAdminChannels.vue?vue&type=script&lang=js&"
export * from "./BucketAdminChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8854a886",
  null
  
)

export default component.exports